import { render, staticRenderFns } from "./ModalConnect.vue?vue&type=template&id=238c6967"
import script from "./ModalConnect.vue?vue&type=script&lang=js"
export * from "./ModalConnect.vue?vue&type=script&lang=js"
import style0 from "./ModalConnect.vue?vue&type=style&index=0&id=238c6967&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports